import { render, staticRenderFns } from "./Dtp.vue?vue&type=template&id=4e6cdacd&scoped=true"
import script from "./Dtp.vue?vue&type=script&lang=js"
export * from "./Dtp.vue?vue&type=script&lang=js"
import style0 from "./Dtp.vue?vue&type=style&index=0&id=4e6cdacd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6cdacd",
  null
  
)

export default component.exports